import { getInbar12GraphsData } from "../api/inbar12";
import { GraphSystems } from "../types";
import useTestId from "./useTestId";
import useGraphsFactory from "./useGraphsFactory";

export default function useInbar12Data({
    systemId,
    historicTestsToShow,
    enabled = true,
}: {
    systemId?: GraphSystems;
    historicTestsToShow: number[];
    enabled?: boolean;
}) {
    const testId = useTestId()!;

    // Create a unique key for the SWR cache
    const swrKey =
        testId && enabled
            ? `graphs:inbar-12-${JSON.stringify({
                  testId,
                  systemId,
                  historicTestsToShow,
              })}`
            : null;

    const fetcher = async () => {
        const newData = await getInbar12GraphsData({
            testId,
            systemId,
            historicTestsToShow,
        });

        return newData;
    };

    return useGraphsFactory(fetcher, swrKey, { keepUnsavedChanges: true });
}
